<template>
  <div class="boxall">
    <div class="page-head">
      <div class="title">渠道推广</div>
      <span class="btn-container">
        <button class="detail-btn" @click="openDetail">
          {{ opened ? '返回' : '详情' }}
          <img src="../assets/images/more_arrow.png" alt="icon" />
        </button>
      </span>
    </div>

    <div class="boxnav">
      <div class="bg-image">
        <div class="content">
          <div class="item-box">
            <div class="item-info">
              <div class="item-label">
                <img src="../assets/images/ecommerce/merchants.png" alt="icon" />
                商户数量
              </div>
              <div class="item-value">
                <span class="num">52</span>
                <span class="unit">户</span>
              </div>
            </div>
          </div>

          <div class="divider">
            <el-divider direction="vertical" />
          </div>

          <div class="item-box">
            <div class="item-info">
              <div class="item-label">
                <img src="../assets/images/ecommerce/groups.png" alt="icon" />
                私域数量
              </div>
              <div class="item-value">
                <span class="num">13</span>
                <span class="unit">个</span>
              </div>
            </div>
          </div>

          <div class="divider">
            <el-divider direction="vertical" />
          </div>

          <div class="item-box">
            <div class="item-info">
              <div class="item-label">
                <img src="../assets/images/ecommerce/goods.png" alt="icon" />
                商品数量
              </div>
              <div class="item-value">
                <span class="num">78</span>
                <span class="unit">种</span>
              </div>
            </div>
          </div>

          <div class="divider">
            <el-divider direction="vertical" />
          </div>

          <div class="item-box">
            <div class="item-info">
              <div class="item-label">
                <img src="../assets/images/ecommerce/orders.png" alt="icon" />
                订单销量
              </div>
              <div class="item-value">
                <span class="num">653</span>
                <span class="unit">单</span>
              </div>
            </div>
          </div>

          <div class="divider">
            <el-divider direction="vertical" />
          </div>

          <div class="item-box">
            <div class="item-info">
              <div class="item-label">
                <img src="../assets/images/ecommerce/total_money.png" alt="icon" />
                销售额
              </div>
              <div class="item-value">
                <span class="num">12</span>
                <span class="unit">万元</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="showWeb" class="website-container">
      <iframe src="http://km6.366kmpf.com/youq" frameborder="0" class="website-frame"></iframe>
    </div>  -->
  </div>
</template>

<script>
export default {
  name: 'ECommerce',

  props: {
    activeComp: {
      type: String,
      default: 'CenterMap'
    }
  },

  data() {
    return {
      // showWeb: false
    }
  },

  computed: {
    opened() {
      return this.activeComp === 'EcommerceDetail'
    }
  },

  methods: {
    openDetail() {
      this.$emit('openDetail')
    }
  }
}
</script>

<style scoped>
@import '../assets/fonts/stylesheet.css';

.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/seafood.jpg') no-repeat center center;
  background-size: cover;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.content {
  height: 35%;
  background: #303030b0;

  flex: 0 0 35%; /* 纵向上高度百分比 */
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  box-sizing: border-box;
}

.item-box {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center; /* 垂直居中 */
  padding: 0 1.2px;
  box-sizing: border-box;
}

.item-label img {
  width: 10px;
  height: 10px;
}

/* 文字区域*/
.item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 6.4px;
}

/* 数字 + 单位 */
.item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.num {
  font-size: 24px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
}

.unit {
  font-size: 12px;
  color: #82d5f1;
}

.item-label {
  font-size: 10px;
  color: #97dbf1;
  /* margin-top: 4px; */
}

.divider {
  display: flex;
  align-items: center;
}

:deep(.el-divider--vertical) {
  height: 28px;
  border-left: 1px dashed #a7a7a7;
}

.page-head {
  position: relative;
}

.btn-container {
  position: absolute;
  top: 8px;
  right: 8px;
}

.detail-btn {
  background: #c7e9f600;
  padding: 2.4px 5px;
  color: #49d8ec;
  font-size: 12px;
  border-radius: 6.4px;
  border: 1.6px solid #49d8ec;
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 12px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);

  cursor: pointer;
}

.detail-btn img {
  height: 8px;
  width: 8px;
}

.website-container {
  width: 100%;
  height: 100%;
}

.website-frame {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
